const mocSilnika = { t: 'Moc', type: 'range', name: 'moc-silnika', unit: 'KM', hint: { url: '/engine_power' }}
export default mocSilnika